import React from 'react'
import { Link } from "react-router-dom";
import styles from './BrandTile.module.css'

function BrandTile(props){

    const { brand, baseUrl } = props

    return (
        <Link to={`${brand.id}`} className={styles['brand-tile']}>
            <img className={styles['brand-image']} src={`${baseUrl}${brand.logo}`} alt={'Brand Image'}/>
            <p className={styles['brand-name']}>{brand.name}</p>
        </Link>
    )
}

export default BrandTile